import { useMemo } from 'react';

import { useDevSandbox } from './DevSandboxProvider';
import { TResolvedTheme } from './types';
import { getThemeColors, IThemeColors } from './useResolvedTheme';

/**
 * Convenience hook for DevSandbox child components.
 * Returns the resolved theme and color tokens.
 */
const useSandboxTheme = (): { resolved: TResolvedTheme; colors: IThemeColors; isLight: boolean } => {
  const { resolvedTheme } = useDevSandbox();
  const colors = useMemo(() => getThemeColors(resolvedTheme), [resolvedTheme]);
  const isLight = resolvedTheme === 'light';

  return { resolved: resolvedTheme, colors, isLight };
};

export default useSandboxTheme;
